import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-149" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-150" data-mp="3fze45yusr5w7">
        <h2 className="text-center font-heading text-[1.15rem] font-extrabold uppercase text-navy sm:text-[1.75rem]" data-id="element-151" data-mp="3fy2z7vpm7s3i">
          What students say
        </h2>
        <div className="mt-2 space-y-2" data-id="element-152" data-mp="36zilza2tqamo">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy/10 bg-clinical px-2.5 py-2" data-id="element-153" data-mp="31zw8r0mzwudv">
              <div className="flex items-center gap-1" aria-label="5 out of 5" data-id="element-154" data-mp="2x1utkqsoxf7o">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3 w-3 fill-gold text-gold" aria-hidden="true" data-id="element-155" data-mp="2s3jjqg2eb4pg" />)}
              </div>
              <blockquote className="mt-1 text-[0.78rem] leading-[1.4] text-graphite sm:text-[0.9rem]" data-id="element-156" data-mp="q8ivtlslzssx">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-1 font-body text-[0.66rem] font-extrabold uppercase tracking-wide text-navy sm:text-[0.76rem]" data-id="element-157" data-mp="m5sysg0nlynm">
                {t.name}
                <span className="block font-semibold normal-case tracking-normal text-graphite/80" data-id="element-158" data-mp="c6lk9pi6nxyx">
                  {t.role} — {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}